export enum TabRoute {
  tasks = "tasks",
  taskTemplates = "templates",
  chats = "chats",
  eduAdmin = "edu-admin",
  eduLessons = "edu-lessons",
  eduFeeds = "edu-feeds",
  eduAssignments = "edu-assignments",
  eduAttendance = "edu-attendance",
  eduSchoolEdit = "edu-school-edit",
  settings = "settings",
  people = "people",
  customers = "customers",
  drive = "drive",
  travelLog = "travelLog",
  cpanel = "cpanel",
  workspaceSettings = "workspace-settings",
}
